export default __webpack_public_path__ + "static/media/jian2.4fbda057.jpg";